<template>
  <main class="complete">


    <!-- 완료 카드 -->
    <section class="card" aria-live="polite">
      <div class="hero">
        <div class="hero__icon">
          <i class="fa-regular fa-circle-check" aria-hidden="true"></i>
        </div>
        <h2 class="hero__title">환영합니다!</h2>
        <p class="hero__desc">
          회원가입이 정상적으로 완료되었습니다.<br />
          이제 ICIK의 다양한 서비스와 소식을 편리하게 이용하실 수 있습니다.
        </p>
      </div>

      <dl class="summary">
        <div class="summary__row">
          <dt>아이디(이메일)</dt>
          <dd>{{ userinfo.email }}</dd>
        </div>
        <div class="summary__row">
          <dt>성명</dt>
          <dd>{{ userinfo.userName }}</dd>
        </div>
        <div class="summary__row">
          <dt>가입일</dt>
          <dd>{{ userinfo.createdAt.slice(0, 10) }}</dd>
        </div>
      </dl>

      <div class="actions">
        <a class="btn btn--primary" href="/login">로그인</a>
        <a class="btn btn--ghost" href="/mypage">마이페이지</a>
      </div>
    </section>
  </main>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'

const store = useStore()

// 간단한 날짜 포맷터 (YYYY.MM.DD)
// function fmtDate(d) {
//   try {
//     const dt = new Date(d)
//     const y = dt.getFullYear()
//     const m = String(dt.getMonth() + 1).padStart(2, '0')
//     const day = String(dt.getDate()).padStart(2, '0')
//     return `${y}.${m}.${day}`
//   } catch { return d || '' }
// }

// 1) 스토어에 값이 있으면 우선 사용(배열/객체 모두 케어)
const rawFromStore = store?.state?.grid?.userData
const fromStore = Array.isArray(rawFromStore) ? rawFromStore[0] : rawFromStore

// 2) 세션스토리지 보조
let fromSS = {}
try { fromSS = JSON.parse(sessionStorage.getItem('joinResult') || '{}') } catch {}

// 3) 최종 머지 + 보기 좋게 정리
// const userinfo = computed(() => {
//   const base = (fromStore && Object.keys(fromStore).length) ? fromStore : fromSS
//   return {
//     email: base.email || base.userId || '',
//     userName: base.userName || '',
//     createdAt: base.createdAtText || fmtDate(base.createdAt)
//   }
// })

const userinfo = computed(() => {
  const raw = store?.state?.grid?.userData
  const fromStore = Array.isArray(raw) ? raw[0] : raw

  let fromSS = {}
  try { fromSS = JSON.parse(sessionStorage.getItem('joinResult') || '{}') } catch {}

  const base = (fromStore && Object.keys(fromStore).length) ? fromStore : fromSS
  return {
    email: base.email || base.userId || '',
    userName: base.userName || '',
    createdAt: base.createdAtText || base.createdAt || ''
  }
})

</script>


<style scoped>
.complete {
  font-family: system-ui, -apple-system, "Segoe UI", "Noto Sans KR",
    "Apple SD Gothic Neo", "Malgun Gothic", Arial, sans-serif;
  padding: 48px 20px 64px;
  background: #f8fafc;
  color: #0f172a;
}

/* 제목/구분선 (이전 페이지들과 동일) */
.complete__title {
  text-align: center;
  font-size: 2rem;
  font-weight: 900;
  letter-spacing: -.2px;
  margin: 8px 0 12px;
}
.complete__divider {
  max-width: 760px;
  margin: 0 auto 24px;
  border: 0;
  border-top: 1px solid #e5e7eb;
}

/* 스텝 (공통) */
.steps {
  list-style: none;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
  max-width: 760px;
  margin: 0 auto 24px;
  padding: 0;
}
.step {
  display: grid;
  grid-template-columns: 44px 1fr;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 999px;
  color: #334155;
}
.step__icon {
  width: 44px; height: 44px;
  border-radius: 999px;
  display: grid; place-items: center;
  background: #f1f5f9;
  color: #334155;
}
.step__text { display: grid; gap: 2px; }
.step__sub { font-size: .75rem; color: #64748b; }
.step strong { font-size: .95rem; font-weight: 800; color: #0f172a; }
.step.is-active {
  border-color: #c7d2fe;
  box-shadow: 0 6px 18px rgba(17,24,39,.06);
}
.step.is-active .step__icon { background: #1d2088; color: #fff; }
.step.is-done { opacity: .85; }

/* 완료 카드 */
.card {
  max-width: 840px;
  margin: 0 auto;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 40px 32px 30px;
  box-shadow: 0 10px 30px rgba(17,24,39,.06);
  text-align: center;
}

/* 히어로 영역 */
.hero { display: grid; place-items: center; gap: 12px; }
.hero__icon {
  width: 72px; height: 72px; border-radius: 999px;
  display: grid; place-items: center;
  background: #1d2088; color: #fff; font-size: 28px;
  box-shadow: 0 8px 24px rgba(29,32,136,.28);
}
.hero__title {
  margin: 14px 0 6px;
  font-size: 1.75rem; font-weight: 900; letter-spacing: -.2px;
}
.hero__desc { color: #334155; line-height: 1.75; }

/* 요약 정보 */
.summary {
  margin: 24px auto 16px;
  max-width: 520px;
  text-align: left;
  border-top: 1px dashed #e5e7eb;
}
.summary__row {
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px dashed #eef2f7;
}
.summary dt { color: #475569; font-weight: 700; }
.summary dd { margin: 0; color: #0f172a; }

/* 버튼 */
.actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: 24px;
}
.btn {
  height: 54px;
  font-size: 16px;
  font-weight: 800;
  border-radius: 12px;
  border: 1px solid transparent;
  display: inline-flex; align-items: center; justify-content: center;
  text-decoration: none;
}
.btn--primary { background: #1d2088; color: #fff; }
.btn--primary:hover { background: #220e52; }
.btn--ghost { background: #fff; color: #0f172a; border-color: #e5e7eb; }
.btn--ghost:hover { background: #f8fafc; border-color: #cbd5e1; }

/* 모바일 */
@media (max-width: 640px) {
  .steps { grid-template-columns: 1fr; }
  .summary__row { grid-template-columns: 110px 1fr; }
  .actions { grid-template-columns: 1fr; }
}
</style>
